import type { FileType, Metadata } from '../upload/types'
import { categories } from '../upload/upload-constants'

const getDisplayCategory = (value: string) => {
  return categories.filter(c => c.value === value)[0].display
}

const createPayload = (file: FileType, meta: Metadata) => {
  const data = new FormData()
  data.append('payloadToken', meta.userToken)
  meta.claim.digitalFileUpload = {
    ...meta.claim.digitalFileUpload,
    file: {
      categoryValue: file.category,
      categoryDescription: getDisplayCategory(file.category),
      name: file.file.name,
      size: file.file.size
    }
  }
  data.append(
    'metadata',
    JSON.stringify(meta, (key, value) => (key !== 'userToken') ? value : undefined)
  )
  data.append('files', file.file)
  return data
}

export { createPayload }
